import React from 'react';
import { Input, RadioGroup, RadioButton, Card } from 'components';
import { CreateListingCardProps, RequiredFields } from '../types';
import { StyledGrid } from './StyledComponents';

type RequiredProps = CreateListingCardProps<RequiredFields>;

const Required: React.FC<RequiredProps> = ({ required, setListing }) => {
  const handleChange = (changes: Partial<RequiredProps['required']>) => {
    setListing(prev => ({
      ...prev,
      required: {
        ...prev.required,
        ...changes,
      },
    }));
  };

  const renderRadioGroup = (
    label: string,
    key: keyof RequiredProps['required'],
    dataCy?: string,
  ) => (
      <RadioGroup
        allowClear
        label={label}
        buttonStyle="solid"
        value={required[key]}
        onChange={({ target: { value } }) => handleChange({ [key]: value })}
        data-cy={dataCy}
      >
        <RadioButton value="No">No</RadioButton>
        <RadioButton value="Yes">Yes</RadioButton>
      </RadioGroup>
    );

  return (
    <Card type="primary" title="Required" id="required">
      <StyledGrid $columns={3}>
        <Input
          label="Lease Term"
          value={required.lease_term}
          onChange={({ target: { value } }) =>
            handleChange({ lease_term: value })
          }
          data-cy="listing-lease-required-lease-term"
        />
        <Input
          label="Payment Method"
          value={required.payment_method}
          onChange={({ target: { value } }) =>
            handleChange({ payment_method: value })
          }
          data-cy="listing-lease-required-payment-method"
        />
        {renderRadioGroup(
          'Rental Application Required',
          'rental_application',
          'listing-lease-required-rental-application',
        )}
        {renderRadioGroup(
          'Deposit Required',
          'deposit',
          'listing-lease-required-deposit',
        )}
        {renderRadioGroup(
          'Credit Check',
          'credit_check',
          'listing-lease-required-credit-check',
        )}
        {renderRadioGroup(
          'Employment Letter Required',
          'employment_letter',
          'listing-lease-required-employment-letter',
        )}
      </StyledGrid>
    </Card>
  );
};

export default React.memo(Required);
